module.exports = __webpack_public_path__ + "static/media/Corded_ware_icon_200px.4c8d8c5e.png";